import * as m from "mithril";
import { NavBar } from "../../components/NavBar";
import AppContext from "../../context/AppContext";
import dayjs = require("dayjs");
import LoadingIndicator from "../../components/LoadingIndicator";
import ConfirmationDetails from "../confirmation/ConfirmationDetails";
import { BookingDTO } from "../../apiclient/ApiDtos";
import './BookingDetailsPage.scss';

interface Attrs {
    appContext: AppContext,
    bookingDetails: BookingDTO | null,
    onBackPressed: () => void
}

function BookingDetailsPage(): m.Component<Attrs> {
    return {
        view(vnode) {
            let messageProvider = vnode.attrs.appContext.getMessageProvider();

            let actionItems = [
                {
                    label: "EN",
                    onclick: () => {
                        vnode.attrs.appContext.setLangauge("en");
                    }
                },
                {
                    label: messageProvider.get("lang.my"),
                    onclick: () => {
                        vnode.attrs.appContext.setLangauge("my");
                    }
                }
            ];
            return [

                m("div", { class: "app-layout" },
                    [
                        m(NavBar, {
                            title: messageProvider.get("my_bookings.booking_details"),
                            canBackPress: true,
                            actionItems: actionItems,
                            onBackPressed: () => {
                                vnode.attrs.onBackPressed();
                            }
                        }),

                        m("div.app-area-main",
                            vnode.attrs.bookingDetails == null ?
                                m(LoadingIndicator) :
                                [                                        
                                    m("div.m-1", 
                                        m(ConfirmationDetails, {
                                            messageProvider: messageProvider,
                                            booking: vnode.attrs.bookingDetails!!
                                        })                                    
                                    )                            
                                    
                                ]
                        )
                    ])
            ]
        }

    }
}

export default BookingDetailsPage;